import { Custom, Input } from "components";
import { useApp } from "context";
import { useForm } from "hooks";
import { useNavigate } from "react-router-dom";
import { Enums, Helpers, Routes } from "utils";

type Props = {
  seconds: number;
  authMethod: Enums.EnumAuthMethod | null;
  handleResend: (authMethod: Enums.EnumAuthMethod) => void;
};

export const AccountVerification = (props: Props) => {
  const { t, user, setFeedback, setUser, service } = useApp();
  const navigate = useNavigate();

  const initialState = { code: "" };

  const { onInput, onSubmit, values } = useForm(submitCallback, initialState);

  async function submitCallback() {
    const { code }: any = values;
    const [status, response] = await service.auth.signin(user.email, { code });

    if (status === Enums.EnumResponse.Success) {
      setFeedback(null);
      setUser({ active: true, ...response });
      navigate(Routes.patient.home);
    } else if (status === Enums.EnumResponse.Unauthorized) {
      setFeedback({
        message: t.message.auth.code_mismatch,
        severity: Enums.EnumFeedback.Error,
      });
    } else {
      setFeedback({
        message: t.message.feedback.request_error,
        severity: Enums.EnumFeedback.Error,
      });
    }
  }

  const usePhone = props.authMethod === Enums.EnumAuthMethod.Phone;

  return (
    <form onSubmit={onSubmit}>
      <Input.VerificationCode name="code" count={6} onInput={onInput} />
      <div className="footnote">
        <Custom.Button
          variant="outlined"
          onClick={() => {
            props.handleResend(props.authMethod as Enums.EnumAuthMethod);
          }}
          disabled={!!props.seconds}
        >
          {!props.seconds
            ? usePhone
              ? t.action.resend_sms
              : t.action.resend_email
            : Helpers.interpolate(
                usePhone
                  ? t.action.resend_sms_seconds
                  : t.action.resend_email_seconds,
                { seconds: props.seconds }
              )}
        </Custom.Button>
        <Custom.Button submit>{t.action.continue}</Custom.Button>
      </div>
    </form>
  );
};
